import { render, staticRenderFns } from "./card-course.vue?vue&type=template&id=3fe8f94c"
import script from "./card-course.vue?vue&type=script&lang=js"
export * from "./card-course.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports